import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch catering service item detail with entire menu setup
 * @param {number} restaurantId - The restaurant ID
 * @param {number} packageId - The catering service item ID
 * @param {string} categoryId - The category ID (optional)
 * @param {string} language - The language parameter (default: 'en')
 * @param {number} currencyId - The currency ID (default: 3)
 * @returns {Promise<Object>} - Response data from the API
 */
export const getCateringPackageDetail = async (
  restaurantId, 
  packageId, 
  categoryId = "", 
  language = "en", 
  currencyId = 3
) => {
  try {
    // Add timestamp to prevent caching and ensure fresh data
    const timestamp = Date.now();
    const response = await apiClient.get(
      `${API_ENDPOINTS.RESTAURANT}/${restaurantId}/catering-service-item/${packageId}?category_id=${categoryId}&language=${language}&currency_id=${currencyId}&_t=${timestamp}`
    );
    return response.data.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 